



<mat-card class="example-card fadeInDown">
  <mat-card-header class="CenterOnHeaer">
      <img src="../../assets/img/reset-password-animate.svg" class="ImgWidth fadeIn first">
  </mat-card-header>
  <mat-card-content>

          <form class="example-form fadeIn second" [formGroup]="myForm">
        
            <!-- <mat-form-field class="example-full-width">
              <input type="password" matInput placeholder="Current password" formControlName="currentPassword" required>

                     <mat-error *ngIf="myForm.hasError('required', 'currentPassword')">
                      password is <strong>required</strong>
                    </mat-error>

                    <mat-error *ngIf="myForm.hasError('pattern', 'currentPassword')">
                      Password must contain at least one letter, at least one number, and be longer than six charaters.
                    </mat-error>

 
           
            </mat-form-field> -->
            <mat-form-field class="example-full-width">
              <input type="password" matInput placeholder="New password" formControlName="password" required>

                     <mat-error *ngIf="myForm.hasError('required', 'password')">
                      password is <strong>required</strong>
                    </mat-error>

                    <mat-error *ngIf="myForm.hasError('pattern', 'password')">
                      Password must contain at least one letter, at least one number, and be longer than six charaters.
                    </mat-error>

 
           
            </mat-form-field>

                  <mat-form-field class="example-full-width">
                          <input type="password" matInput placeholder="Confirm password" formControlName="confirmPassword"  >
                                 <mat-error *ngIf="myForm.hasError('required', 'confirmPassword')">
                                  password is <strong>required</strong>
                                </mat-error>
                                <mat-error *ngIf="myForm.hasError('notSame')">
                                  Passwords 
                                  <strong>not match</strong>
                                </mat-error> 
                        </mat-form-field>

                   <br/>

                        <button type="submit" class="full fadeIn third secondary" (click)="ChangePassword()" mat-raised-button  [disabled]="!myForm.valid">Confirm</button>


                </form>
                <mat-divider></mat-divider>
                <!-- <button type="button" class="full fadeIn fourth" mat-button color="primary" [routerLink]="['/login']">Login</button> -->

  </mat-card-content>

</mat-card>



<!-- 
<form [formGroup]="myForm">
<mat-form-field>
<input matInput placeholder="New password" formControlName="password" required>
<mat-error *ngIf="myForm.hasError('required', 'password')">
Please enter your newpassword
</mat-error>
</mat-form-field>

<mat-form-field>
<input matInput placeholder="Confirm password" formControlName="confirmPassword"  >
<mat-error *ngIf="myForm.hasError('notSame')">
Passwords do not match
</mat-error>  
</mat-form-field>
</form> -->